import React, { ComponentType } from 'react';

import BaseReactionItem from './BaseReactionItem';
import ToggleReactionItem from './ToggleReactionItem';

import {
  IReactionItem,
  ReactionItemTypes,
  ReactionItemPropsMap,
} from './interfaces';

const components: ReactionItemTypes = {
  default: BaseReactionItem,
  toggle: ToggleReactionItem,
};

const ReactionItem = ({ reaction, onClick }: IReactionItem) => {
  const { type = 'default', ...reactionRest } = reaction;

  const ReactionItem = components[type] as ComponentType<
    ReactionItemPropsMap[typeof type]
  >;

  return <ReactionItem onClick={onClick} {...reactionRest} />;
};

export default ReactionItem;
